import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import type { MangaItem } from '@/mocks/manga';

interface PopularSectionProps {
  mangaList: MangaItem[];
}

export default function PopularSection({ mangaList }: PopularSectionProps) {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最受读者欢迎的韩国漫画</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {mangaList.map((manga, index) => (
            <div key={manga.slug} className="relative">
              <div className="absolute -top-1 -left-1 z-10 w-7 h-7 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-xs font-bold">
                {index + 1}
              </div>
              <MangaCard manga={manga} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}